import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextareaModule } from 'primeng/inputtextarea';

@Component({
  providers: [MessageService],
  standalone: true,
  imports: [ButtonModule, DynamicDialogModule, FloatLabelModule, InputTextareaModule, FormsModule],
  templateUrl: './unpublished-archive-confirmation.component.html',
})
export class UnpublishedArchiveConfirmationComponent implements OnInit {
  endMessage = '';

  constructor(private ref: DynamicDialogRef) {}

  ngOnInit() {
    this.endMessage = '';
  }

  closeDialog() {
    this.ref.close();
  }

  archive(endMessage: string) {
    this.ref.close({ endMessage, action: 'archive' });
  }

  delete() {
    this.ref.close({ action: 'delete' });
  }
}
